import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const NotAsVariablesSection = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<div className="flex flex-col gap-4">
			<p className="text-base">{translation.notAsVariablesDescription}</p>

			<img
				className="mt-6"
				src="/img/codelist-changelog/not-as-variables.png"
				alt={translation.imgAlt}
			/>
		</div>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		imgAlt: 'An image showing not to include social security number as a variable',
		notAsVariablesDescription:
			"Personal identifiable information should not be stored as variables in the dataset, but in the project's codelist. It is not permitted to store personal identifiable information as regular variables."
	},

	[LanguageType.Norwegian]: {
		imgAlt: 'Et bilde som viser at man ikke skal inkludere personnummer som en variabel',
		notAsVariablesDescription:
			'Personlige identifiserbar informasjon skal ikke lagres som variabler i datasettet, men i prosjektets kodeliste. Det er ikke godkjent å lagre personlig identifiserbar informasjon som vanlige variabler.'
	}
};
